import { LANGUAGE } from '../../../config/storyblok/languages'

const GERMAN_SPEAKING_COUNTRIES = ['de', 'at', 'ch']
const LANGUAGE_PREFERENCE_KEY = 'preferred_language'

export const saveLanguagePreference = (language: LANGUAGE) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_PREFERENCE_KEY, language)
  }
}

export const getStoredLanguagePreference = (): LANGUAGE | null => {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(LANGUAGE_PREFERENCE_KEY)
    if (stored && Object.values(LANGUAGE).includes(stored as LANGUAGE)) {
      return stored as LANGUAGE
    }
  }
  return null
}

const isGermanLanguage = (lang: string): boolean => {
  if (!lang) return false

  // Handle both language-only codes (e.g., 'de') and language-country codes (e.g., 'de-DE')
  const [language, country] = lang.toLowerCase().split('-')

  // Return true if either:
  // 1. The language is German, or
  // 2. The country code matches a German-speaking country
  return language === 'de' || (country && GERMAN_SPEAKING_COUNTRIES.includes(country))
}

export const detectUserLanguage = (): LANGUAGE => {
  // First check if there's a stored preference
  const storedPreference = getStoredLanguagePreference()
  if (storedPreference) {
    return storedPreference
  }

  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return LANGUAGE.EN
  }

  // Get user's language preferences
  const userLanguages = navigator.languages || [navigator.language] || []

  // Check if any of the user's languages indicate they're from a German-speaking country
  const isGermanSpeaking = userLanguages.some(isGermanLanguage)

  return isGermanSpeaking ? LANGUAGE.DE : LANGUAGE.EN
}
